// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Create Tournament Modal Styles - Unique naming */
.create-tournament-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}

.create-tournament-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.25);
  max-width: 600px;
  width: 95vw;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: createTournamentModalSlideIn 0.3s ease-out;
}

.create-tournament-modal-header {
  padding: 1.5rem 1.5rem 1rem;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.create-tournament-modal-header h2 {
  margin: 0;
  color: #1e293b;
  font-size: 1.5rem;
  font-weight: 700;
}

.create-tournament-modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #64748b;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.create-tournament-modal-close:hover {
  background-color: #f1f5f9;
  color: #374151;
}

.tournament-form {
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1 1;
}

.form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.create-tournament-form-group {
  flex: 1 1;
  margin-bottom: 1rem;
}

.create-tournament-form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
}

.create-tournament-form-group input,
.create-tournament-form-group select,
.create-tournament-form-group textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  transition: border-color 0.2s;
  background: white;
  color: #1f2937;
}

.create-tournament-form-group input:focus,
.create-tournament-form-group select:focus,
.create-tournament-form-group textarea:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

/* Specific styling for date and number inputs */
.create-tournament-form-group input[type="date"],
.create-tournament-form-group input[type="number"] {
  color: #1f2937;
  background: white;
}

.create-tournament-form-group input[type="date"]::-webkit-datetime-edit,
.create-tournament-form-group input[type="date"]::-webkit-datetime-edit-text,
.create-tournament-form-group input[type="date"]::-webkit-datetime-edit-month-field,
.create-tournament-form-group input[type="date"]::-webkit-datetime-edit-day-field,
.create-tournament-form-group input[type="date"]::-webkit-datetime-edit-year-field {
  color: #1f2937;
}

.create-tournament-form-group input[type="date"]::-webkit-calendar-picker-indicator {
  filter: none;
  opacity: 1;
}

.create-tournament-form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.form-actions {
  padding: 1.5rem;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  background: #f8fafc;
}

.cancel-btn {
  background: #475569;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.375rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
}

.cancel-btn:hover {
  background: #64748b;
}

.submit-btn {
  background: #059669;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.375rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(5, 150, 105, 0.2);
}

.submit-btn:hover:not(:disabled) {
  background: #047857;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(5, 150, 105, 0.3);
}

.submit-btn:disabled {
  background: #6b7280;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

@keyframes createTournamentModalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .modal {
    width: 98vw;
    max-height: 95vh;
    margin: 0.5rem;
  }
  
  .modal-header {
    padding: 1rem;
  }
  
  .modal-header h2 {
    font-size: 1.25rem;
  }
  
  .tournament-form {
    padding: 1rem;
  }
  
  .form-row {
    flex-direction: column;
    gap: 0;
  }
  
  .form-actions {
    padding: 1rem;
    flex-direction: column;
  }
  
  .form-actions button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/modals/CreateTournamentModal.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,gDAAgD;AAChD;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Create Tournament Modal Styles - Unique naming */\n.create-tournament-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.create-tournament-modal {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.25);\n  max-width: 600px;\n  width: 95vw;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: createTournamentModalSlideIn 0.3s ease-out;\n}\n\n.create-tournament-modal-header {\n  padding: 1.5rem 1.5rem 1rem;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.create-tournament-modal-header h2 {\n  margin: 0;\n  color: #1e293b;\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n\n.create-tournament-modal-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #64748b;\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 4px;\n  transition: all 0.3s ease;\n}\n\n.create-tournament-modal-close:hover {\n  background-color: #f1f5f9;\n  color: #374151;\n}\n\n.tournament-form {\n  padding: 1.5rem;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.form-row {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.create-tournament-form-group {\n  flex: 1;\n  margin-bottom: 1rem;\n}\n\n.create-tournament-form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.875rem;\n}\n\n.create-tournament-form-group input,\n.create-tournament-form-group select,\n.create-tournament-form-group textarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  transition: border-color 0.2s;\n  background: white;\n  color: #1f2937;\n}\n\n.create-tournament-form-group input:focus,\n.create-tournament-form-group select:focus,\n.create-tournament-form-group textarea:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n/* Specific styling for date and number inputs */\n.create-tournament-form-group input[type=\"date\"],\n.create-tournament-form-group input[type=\"number\"] {\n  color: #1f2937;\n  background: white;\n}\n\n.create-tournament-form-group input[type=\"date\"]::-webkit-datetime-edit,\n.create-tournament-form-group input[type=\"date\"]::-webkit-datetime-edit-text,\n.create-tournament-form-group input[type=\"date\"]::-webkit-datetime-edit-month-field,\n.create-tournament-form-group input[type=\"date\"]::-webkit-datetime-edit-day-field,\n.create-tournament-form-group input[type=\"date\"]::-webkit-datetime-edit-year-field {\n  color: #1f2937;\n}\n\n.create-tournament-form-group input[type=\"date\"]::-webkit-calendar-picker-indicator {\n  filter: none;\n  opacity: 1;\n}\n\n.create-tournament-form-group textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.form-actions {\n  padding: 1.5rem;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  background: #f8fafc;\n}\n\n.cancel-btn {\n  background: #475569;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.cancel-btn:hover {\n  background: #64748b;\n}\n\n.submit-btn {\n  background: #059669;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.2s;\n  box-shadow: 0 2px 4px rgba(5, 150, 105, 0.2);\n}\n\n.submit-btn:hover:not(:disabled) {\n  background: #047857;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(5, 150, 105, 0.3);\n}\n\n.submit-btn:disabled {\n  background: #6b7280;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n@keyframes createTournamentModalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .modal {\n    width: 98vw;\n    max-height: 95vh;\n    margin: 0.5rem;\n  }\n  \n  .modal-header {\n    padding: 1rem;\n  }\n  \n  .modal-header h2 {\n    font-size: 1.25rem;\n  }\n  \n  .tournament-form {\n    padding: 1rem;\n  }\n  \n  .form-row {\n    flex-direction: column;\n    gap: 0;\n  }\n  \n  .form-actions {\n    padding: 1rem;\n    flex-direction: column;\n  }\n  \n  .form-actions button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
